<template>
  <v-container fluid>
    <v-card outlined max-width="1000">
      <div class="mx-6 mt-4">
        <v-card-title>Users</v-card-title>
        <v-select
          :items="users"
          item-text="username"
          item-value="user_id"
          outlined
          class="mt-4"
        ></v-select>
      </div>
    </v-card>
    <v-card outlined max-width="1000" class="mt-4">
      <div class="mx-6 my-4">
        <v-card-title>New User</v-card-title>
        <v-text-field
          label="Firstname"
          v-model="new_user.firstname"
        ></v-text-field>
        <v-text-field
          label="Lastname"
          v-model="new_user.lastname"
        ></v-text-field>
        <v-text-field
          label="Username"
          v-model="new_user.username"
        ></v-text-field>
        <v-text-field
          label="Email"
          v-model="new_user.email"
        ></v-text-field>
        <v-text-field
          label="Password"
          v-model="new_user.password"
          disabled
        ></v-text-field>
        <div class="d-flex">
          <v-btn
            @click="create_user"
            :loading="create_loader"
          >CREATE USER</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="reset_form"
            :disabled="create_loader"
          >RESET FORM</v-btn>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */

export default {
  name: "users-page",
  data() {
    return {
      users: [],
      new_user: {
        firstname: '',
        lastname: '',
        username: '',
        email: '',
        password: '',
      },
      create_loader: false,
    };
  },
  computed: {

  },
  methods: {
    loadUsers() {
      // return
      if (this.users.length === 0) {
        const payload = { task: "getUsers" };
        this.$store
          .dispatch("productionModule/general_api", payload)
          .then((res) => {
            console.log("loadUsers", res.data);
            this.users = res.data.payload.users
          });
      }
    },
    create_user() {
      if(this.new_user.email === '') this.new_user.email = null
      this.create_loader = true;
      console.log('create user', this.new_user)
      const payload = { task: "createUser", payload: { newUser: this.new_user } };
      this.$store
        .dispatch("productionModule/general_api", payload)
        .then((res) => {
          console.log("loadUsers", res.data);
          this.new_user.password = res.data.password
        }).finally(() => {this.create_loader = false})
    },
    reset_form() {
      this.new_user = {
        firstname: '',
        lastname: '',
        username: '',
        email: '',
        password: '',
      }
    }
  },
  watch: {

  },
  mounted() {
    this.loadUsers();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/Users.vue